import React from 'react';
import Styles from './create-account-navigation-styles.scss';
import { ButtonBack } from '../../pages/signup/components';
import ButtonKVBase from '../button-kv/button-kv';
import classNames from 'classnames';
const CreateAccountNavigation = ({ onClickContinue, handleOnClickBack, continueButtonDisabled, backButtonDisabled, wrapperCustomStyle, customButtonText = 'Continue' }) => {
    return (React.createElement("div", { className: classNames(Styles.wrapper, wrapperCustomStyle) },
        React.createElement(ButtonBack, { onClick: handleOnClickBack, disabled: backButtonDisabled, testId: "back-button", btnBackgroundGradient: "" }),
        React.createElement("div", { className: Styles.continue },
            React.createElement(ButtonKVBase, { type: 'button', onClick: onClickContinue, className: Styles.submitButton, btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", disabled: continueButtonDisabled, testId: "continue-button", btnWrapClass: Styles.btnWrap }, customButtonText))));
};
export default CreateAccountNavigation;
